import React, {useMemo} from 'react';
import Form, {FormContent} from '../../components/form/Form'
import {incomeInfoForm} from '../../formDefinitions/IncomeInfoForm/IncomeInfoForm'
import {useDispatch, useSelector} from 'react-redux'
import {apphistory, AppState} from '../../store'
import {AdditionalFormNames, FormNames, TAllAdditionalFieldsNames} from '../../models/form/IFormDefinition'
import {additionalIncomeForm} from '../../formDefinitions/IncomeInfoForm/AdditionalIncomeForm'
import Switch from '../../components/form/Switch/Switch'
import {TOGGLE_ADDITIONAL_FROM} from '../../store/actions/form-actions'
import {
    additionalIncomeAdditionalInfoFieldsDefinition
} from '../../formDefinitions/IncomeInfoForm/AdditionalIncomeFields'
import useIncomeInfoFormLogic from './hooks/useIncomeInfoFormLogic'
import Paragraph from "../../components/atoms/Paragraph/Paragraph";
import PageScreen from "../../components/organisms/Page/PageScreen";
import useTextContents from "../../hooks/useTextContents";
import {AppLinks} from "../../environment/app-links";
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'
import { WorkflowTypes } from '../../common/workflow'
import BIKHiddenInputs from '../../components/molecules/BIKHiddenInputs/BIKHiddenInputs'


const AdditionalIncomeAdditionalForm = () => {
    const additionalIncomeFormState = useSelector((state: AppState) => state.formState[AdditionalFormNames.AdditionalIncomeForm])

    const currentAdditionalIncomeInfoFields = useMemo(() => {
        if (additionalIncomeFormState?.formConfig?.currentIncomeInfoFields !== undefined) {
            const newIncomeInfoFields: Record<string, any> = {}

            additionalIncomeFormState.formConfig.currentIncomeInfoFields.forEach(fieldName => {
                newIncomeInfoFields[fieldName] = additionalIncomeAdditionalInfoFieldsDefinition[fieldName]
            })

            return {
                ...additionalIncomeForm.additionalFields,
                ...newIncomeInfoFields,
            }
        }

        return {...additionalIncomeForm.additionalFields}

    }, [additionalIncomeFormState?.formConfig?.currentIncomeInfoFields])


    if (additionalIncomeFormState === undefined) {
        return null
    }

    return (
        <FormContent
            fields={currentAdditionalIncomeInfoFields}
            formName={additionalIncomeForm.name}
            formLabel={additionalIncomeForm.label}
            fieldsState={additionalIncomeFormState.fieldsData}  // This will always get the most up-to-date fieldsData
            formValidationFunctions={additionalIncomeForm.formValidationFunctions}
        />
    )
}

const IncomeInfoForm = () => {
    const dispatch = useDispatch()
    const textContents = useTextContents()

    const {
        showAdditionalForm,
        currentIncomeInfoFields,
        incomeInfoState,

        handleOnIncomeInfoFormSubmit,
        setShowAdditionalForm,
    } = useIncomeInfoFormLogic()



    const handleBackClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        apphistory.push(AppLinks.addressInfoForm)
    }


    return (

        <PageScreen
            title={{title: "Twoje dochody i wydatki", line: true}}
            panel={<LoanOfferSummaryPanel loanVariant="predefined" />}
            showBackButton={true}
            onClickBack={handleBackClick}
        >
            <BIKHiddenInputs showInputs={WorkflowTypes.isFromOpenaForm()} />
            <Form
                fields={currentIncomeInfoFields}
                form={incomeInfoForm}
                formState={incomeInfoState}
                isFinalPage={true}
                onFormSubmit={handleOnIncomeInfoFormSubmit}
            >
                <Switch
					dataTestId="additional-income-form-switch"
					isChecked={showAdditionalForm}
                    handleOnSwitch={() => {
                        dispatch({
                            type: TOGGLE_ADDITIONAL_FROM,
                            payload: {
                                formName: additionalIncomeForm.name,
                                isAdditionalFormOpen: !showAdditionalForm,
                                additionalFieldsNamesToAdd: Object.keys(additionalIncomeForm.additionalFields) as TAllAdditionalFieldsNames[]
                            }
                        })
                        setShowAdditionalForm(!showAdditionalForm)
                    }}
                    label={additionalIncomeForm.switchLabel}
                    additionalFormName={additionalIncomeForm.name}
                />
                {
                    showAdditionalForm &&
                    <AdditionalIncomeAdditionalForm/>
                }
            </Form>
        </PageScreen>

    )
}

export default IncomeInfoForm